<!-- 商品分类 -->

<template>
  <div class="main" v-loading="loading">
    <!-- 顶部搜索 -->
    <div class="s_wrapper">
      <el-input class="s_input" placeholder="搜索分类名称" suffix-icon="el-icon-search" v-model="categoryName"
        :clearable="true" @change="onSearch"></el-input>
      <el-button class="btn" type="primary" @click="handleAddOne">新增一级分类</el-button>
    </div>

    <!-- 表格 -->
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540" row-key="categoryId">
        <el-table-column show-overflow-tooltip min-width="120" prop="categoryName" label="分类名称"></el-table-column>
        <!-- <el-table-column label="图片">
          <template slot-scope="scope">
            <span class="show_img" @click="previewPic(scope.row.picturePath)"
              v-if="scope.row.parentCategoryId == 0">查看图片</span>
            <span v-else>-</span>
          </template>
</el-table-column> -->
        <el-table-column show-overflow-tooltip min-width="120" prop="sort" label="排序"></el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="300" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.parentCategoryId == 0" class="btn" type="primary" plain
              @click="handleAddTwo(scope.row)">新增二级分类</el-button>
            <el-button class="btn" type="" plain @click="handleEdit(scope.row)">修改</el-button>
            <el-button class="btn" type="danger" plain @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <!-- 分类弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @close="handleCloseDialog">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" class="demo-ruleForm" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="一级类目" prop="categoryOne">
              <el-input v-model="ruleForm.categoryOne" placeholder="请输入"
                :disabled="isCategoryTwoAdd || isCategoryTwoEdit"></el-input>
            </el-form-item>
            <el-form-item label="二级类目" prop="categoryTwo" v-if="isCategoryTwoAdd || isCategoryTwoEdit">
              <el-input v-model="ruleForm.categoryTwo" placeholder="请输入"></el-input>
            </el-form-item>
            <!-- <el-form-item label="图片" prop="picUrl" v-if="isCategoryOneAdd || isCategoryOneEdit">
              <el-upload class="avatar-uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action"
                :headers="headers" :show-file-list="false" :on-success="handleSuccess" :on-remove="handleRemove"
                :before-upload="beforeUpload">
                <img v-if="ruleForm.picUrl" :src="ruleForm.picUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过100kb，图片尺寸1:1</div>
              </el-upload>
            </el-form-item> -->
          </el-col>
          <el-col :span="12">
            <el-form-item label="一级排序" prop="sortOne">
              <el-input v-model="ruleForm.sortOne" placeholder="请输入"
                :disabled="isCategoryTwoAdd || isCategoryTwoEdit"></el-input>
            </el-form-item>
            <el-form-item label="二级排序" prop="sortTwo" v-if="isCategoryTwoAdd || isCategoryTwoEdit">
              <el-input v-model="ruleForm.sortTwo" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" plain @click="handleCloseDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>

    <el-image-viewer v-if="showViewer" :on-close="() => {
      showViewer = false
    }
      " :url-list="srcList"></el-image-viewer>
  </div>
</template>

<script>
export default {
  components: {
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      loading: false,
      categoryName: "", // 搜索分类
      // 上传图片
      action: this.$axios.defaults.baseURL + this.$api.uploadFile,
      headers: {
        token: this.$store.state.token
      },
      // 表格数据
      tableData: [],
      // 弹窗
      dialogVisible: false,
      dialogTitle: "",
      isCategoryOneAdd: false, // 一级分类新增
      isCategoryOneEdit: false, // 一级分类编辑
      isCategoryTwoAdd: false, // 二级分类新增
      isCategoryTwoEdit: false, // 二级分类编辑
      ruleForm: {
        categoryOne: "",
        sortOne: "",
        categoryTwo: "",
        sortTwo: "",
        categoryId: "",
        //  picUrl: "",
      },
      rules: {
        // picUrl: [{
        //   required: true,
        //   message: "请上传图片",
        //   trigger: "blur",
        // },],
        categoryOne: [{
          required: true,
          message: "请输入一级类目",
          trigger: "blur",
        },],
        sortOne: [{
          required: true,
          message: "请输入一级排序",
          trigger: "blur",
        },
        {
          validator: function (rule, value, callback) {
            if (/^[1-9]\d*$/.test(value) == false) {
              callback(new Error("请输入整数"))
            } else {
              //校验通过
              callback()
            }
          },
          trigger: "blur",
        },
        ],
        categoryTwo: [{
          required: true,
          message: "请输入二级类目",
          trigger: "blur",
        },],
        sortTwo: [{
          required: true,
          message: "请输入二级排序",
          trigger: "blur",
        },
        {
          validator: function (rule, value, callback) {
            if (/^[1-9]\d*$/.test(value) == false) {
              callback(new Error("请输入整数"))
            } else {
              //校验通过
              callback()
            }
          },
          trigger: "blur",
        },
        ],
      },

      showViewer: false,
      srcList: [],
      // 分页
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getCategoryList()
  },
  methods: {
    // 列表
    getCategoryList() {
      this.loading = true
      this.$axios
        .get(this.$api.getCategoryList, {
          params: {
            categoryName: this.categoryName || null,
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalItemsCount = res.result.totalCount
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 图片预览
    previewPic(e) {
      this.srcList[0] = e
      this.showViewer = true
    },
    // // 删除文件
    // handleRemove() {
    //   this.ruleForm.picUrl = ""
    // },
    // // 文件上传成功
    // handleSuccess(res) {
    //   if (res.code == 100) {
    //     this.ruleForm.picUrl = res.result.fileId;
    //     this.ruleForm.picUrl = res.result.fileUrl;
    //   } else {
    //     this.$message.error(res.desc);
    //   }
    // },
    // beforeUpload(file) {
    //   const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png"
    //   const isLt5M = file.size / 1024 / 1024 < 5
    //   if (!isJPG) {
    //     this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!")
    //   }
    //   if (!isLt5M) {
    //     this.$message.error("上传图片大小不能超过 5MB!")
    //   }
    //   return isJPG && isLt5M
    // },
    // 新增一级分类
    handleAddOne() {
      this.dialogTitle = "新增一级分类"
      this.dialogVisible = true
      this.isCategoryOneAdd = true
    },
    // 新增二级分类
    handleAddTwo(row) {
      this.$set(this.ruleForm, "categoryOne", row.categoryName)
      this.$set(this.ruleForm, "sortOne", row.sort)
      this.$set(this.ruleForm, "categoryId", row.categoryId)
      this.dialogTitle = "新增二级分类"
      this.dialogVisible = true
      this.isCategoryTwoAdd = true
    },
    // 修改
    handleEdit(row) {
      this.dialogVisible = true
      if (row.parentCategoryId == 0) {
        this.dialogTitle = "修改一级分类"
        this.isCategoryOneEdit = true
        this.$set(this.ruleForm, "categoryOne", row.categoryName)
        this.$set(this.ruleForm, "sortOne", row.sort)
        this.$set(this.ruleForm, "categoryId", row.categoryId)
        // this.$set(this.ruleForm, "picUrl", row.picturePath)
      } else {
        this.dialogTitle = "修改二级分类"
        this.isCategoryTwoEdit = true
        this.$set(this.ruleForm, "categoryOne", row.parentCategoryName)
        this.$set(this.ruleForm, "sortOne", row.parentCategorySort)
        this.$set(this.ruleForm, "categoryTwo", row.categoryName)
        this.$set(this.ruleForm, "sortTwo", row.sort)
        this.$set(this.ruleForm, "categoryId", row.categoryId)
      }
    },
    // 关闭弹窗
    handleCloseDialog() {
      this.dialogVisible = false
      this.dialogTitle = ""
      this.resetForm()
      this.ruleForm = {}
      this.isCategoryOneAdd = false
      this.isCategoryOneEdit = false
      this.isCategoryTwoAdd = false
      this.isCategoryTwoEdit = false
    },
    // 表单校验
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          console.log("error submit!!")
          return false
        } else {
          // 请求方式
          let requestMethod
          // api
          let apiUrl
          if (this.isCategoryOneAdd || this.isCategoryTwoAdd) {
            apiUrl = this.$api.newAddCategory
            requestMethod = "post"
          } else if (this.isCategoryOneEdit || this.isCategoryTwoEdit) {
            apiUrl = this.$api.newUpdateCategory
            requestMethod = "put"
          }
          // 传参
          let data
          if (this.isCategoryOneAdd) {
            data = {
              categoryName: this.ruleForm.categoryOne,
              sort: this.ruleForm.sortOne,
              // picUrl: this.ruleForm.picUrl,
            }
          } else if (this.isCategoryTwoAdd) {
            data = {
              categoryName: this.ruleForm.categoryTwo,
              sort: this.ruleForm.sortTwo,
              parentId: this.ruleForm.categoryId,
            }
          } else if (this.isCategoryOneEdit) {
            data = {
              categoryName: this.ruleForm.categoryOne,
              sort: this.ruleForm.sortOne,
              // picUrl: this.ruleForm.picUrl,
              categoryId: this.ruleForm.categoryId,
            }
          } else if (this.isCategoryTwoEdit) {
            data = {
              categoryName: this.ruleForm.categoryTwo,
              sort: this.ruleForm.sortTwo,
              categoryId: this.ruleForm.categoryId,
            }
          }
          this.$axios[requestMethod](apiUrl, data)
            .then(res => {
              if (res.code == 100) {
                this.$message.success(res.desc)
                this.getCategoryList()
                this.handleCloseDialog()
              }
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        }
      })
    },
    // 删除
    handleDelete(row) {
      this.$confirm("是否要删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .put(`${this.$api.newDeleteCategory}/${row.categoryId}`)
            .then(res => {
              if (res.code == 100) {
                this.$message.success(res.desc)
                this.getCategoryList()
              }
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => {
          this.$message("取消删除")
        })
    },
    // 默认弹窗设置重置表单
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    // 搜索
    onSearch() {
      this.clearData()
      this.getCategoryList()
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.clearData()
      this.pageSize = e
      this.getCategoryList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getCategoryList()
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  .show_img {
    color: $themes;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }

  // 上传图片
  .avatar-uploader ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader ::v-deep .el-upload:hover {
    border-color: $themes;
  }

  .avatar-uploader-icon {
    font-size: 20px;
    color: $themes;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
    object-fit: cover;
  }
}
</style>
